import React from 'react'

import { ErrorGroupState, ErrorStatusCode } from '../../domain/Error'

interface Props {
    status: ErrorStatusCode
}

class DetailsStatusLabel extends React.Component<Props> {
    public render() {
        switch (this.props.status) {
            case ErrorGroupState.ALWAYS_IGNORED:
                return <span className="label label-default">Ignored</span>
            case ErrorGroupState.IGNORED:
                return <span className="label label-default">Ignored</span>
            case ErrorGroupState.RESOLVED:
                return <span className="label label-success">Resolved</span>
            default:
                return <span className="label label-danger">Open</span>
        }
    }
}

export default DetailsStatusLabel
